export const FIRST_VISIT = 'First Visit';
export const TIME_TO_FIRST_INTERACTION = 'Time to First Interaction';

export const SCENE_ENTERED = 'Scene Entered';
export const SCENE_EXITED = 'Scene Exited';
export const SCENE_PREVIEW_LOADED = 'Scene Preview Loaded';
export const SCENE_FULLY_LOADED = 'Scene Fully Loaded';
export const SCENE_LOAD_FAILED = 'Scene Load Failed';
export const ASSET_CDN_FALLBACK = 'Asset CDN Fallback';

export const POI_VIEWED = 'POI Viewed';
export const POI_DETAIL_CLOSED = 'POI Detail Closed';
export const SCENE_POI_VISITED = 'Scene POI Visited';
export const SCENE_COMPLETED = 'Scene Completed';
export const NEXT_SCENE_HINTED = 'Next Scene Hinted';

export const ASSISTANT_MESSAGE_SENT = 'Assistant Message Sent';
export const ASSISTANT_RESPONSE_RECEIVED = 'Assistant Response Received';
export const ASSISTANT_RESPONSE_FAILED = 'Assistant Response Failed';
export const SCENE_OPEN_FAILED = 'Scene Open Failed';
export const SUGGESTION_CLICKED = 'Suggestion Clicked';

export const POI_ARTIFACT_OPENED = 'POI Artifact Opened';
export const POI_ARTIFACT_CLOSED = 'POI Artifact Closed';

export const INSIDE_SCENE_ENTERED = 'Inside Scene Entered';
export const INSIDE_SCENE_EXITED = 'Inside Scene Exited';

export const NEXT_SCENE_CHIP_CLICKED = 'Next Scene Chip Clicked';
export const SCENE_BANNER_CLICKED = 'Scene Banner Clicked';
export const INSIDE_POI_CLICKED = 'Inside POI Clicked';

export const MENU_OPENED = 'Menu Opened';
export const MENU_CLOSED = 'Menu Closed';
export const MENU_SCENE_SELECTED = 'Menu Scene Selected';
export const MENU_TAB_SWITCHED = 'Menu Tab Switched';

export const SESSION_EXIT = 'Session Exit';
export const SESSION_SUMMARY = 'Session Summary';

export const LAYOUT_MODE_CHANGED = 'Layout Mode Changed';

export const ERROR_OCCURRED = 'Error Occurred';
export const UNHANDLED_REJECTION = 'Unhandled Rejection';
export const WEBGL_CONTEXT_LOST = 'WebGL Context Lost';

export const FPS_SNAPSHOT = 'FPS Snapshot';
export const SCENE_PERFORMANCE_SUMMARY = 'Scene Performance Summary';
export const LOW_BATTERY_WARNING = 'Low Battery Warning';
export const MEMORY_SNAPSHOT = 'Memory Snapshot';

export const CHAT_PANEL_MODE_CHANGED = 'Chat Panel Mode Changed';
export const PHOTO_VIEWER_OPENED = 'Photo Viewer Opened';
export const PHOTO_VIEWER_CLOSED = 'Photo Viewer Closed';
export const CAMERA_SESSION = 'Camera Session';
export const OVERALL_SLIDER_SLIDE_CHANGED = 'Overall Slider Slide Changed';

export const HISTORICAL_FEATURE_OPENED = 'Historical Feature Opened';
export const HISTORICAL_FEATURE_CLOSED = 'Historical Feature Closed';
export const HISTORICAL_SLIDER_SLIDE_CHANGED = 'Historical Slider Slide Changed';
export const HISTORICAL_SCENE_SELECTED = 'Historical Scene Selected';
export const ERA_SCENE_ENTERED = 'Era Scene Entered';
